import React , {useEffect,useState}from 'react';
import classes from './About.css';
import Container from '../../../hoc/Container/Container';
import axios from '../../../firebase-axios';
const about = (props) => {
 
     const [state,setState] = useState({about:'loading...'});
    useEffect(() => {
        axios.get('about.json').then(res => {
        setState({about:res.data});
    }).catch((err) => {
        alert('Something Went Wrong');
        console.log(err);
    })
 },[]);

 return (
 <section id="about-me" className={classes.aboutMe} >
    <h2 className="site-section-title appTextPrimary">About Me</h2>
    <Container >
        <div className="appPBx" >
        <p>{state.about}</p>
        </div>
    </Container>
    </section>
 );
};

export default about;


// WEBPACK FOOTER //
// ./src/components/Sections/About/About.js